import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import { Wrapper, BackDrop, Aside, Header, CloseButton, Title, Content } from './styles'

function Drawer ({ visible, onClose, title, children }) {
  useEffect(() => (visible ? enableBodyScroll() : disableBodyScroll()), [visible])

  return (
    <Wrapper visible={visible}>
      <BackDrop onClick={onClose} />

      <Aside>
        <Header>
          {onClose && (
            <CloseButton onClick={onClose} />
          )}
          <Title>{title}</Title>
        </Header>
        <Content>
          {children}
        </Content>
      </Aside>
    </Wrapper>
  )
}

Drawer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  children: PropTypes.node
}

Drawer.defaultProps = {
  visible: false
}

export default Drawer
